export const payment_method_groups_panoramic_selection = `
            key
            title
            payment_methods {
                key
                title
                option_id
                option_type
                image
                image_dark_mode
                additional_image
                additional_image_dark_mode
                payout_condition
                payment_rails {
                    key
                    title
                }
                is_obt_supported
                recently_used
                recently_used_template {
                    token
                    label
                    expiration
                    payment_rail {
                        key
                        title
                    }
                }
                payment_method_type
                payment_information {
                    currency
                    rate
                    limits  {
                        min_amount
                        max_amount
                    }
                    fees {
                        flat_fee_amount
                        percentage_fee
                        is_included
                        min_transaction_amount
                        max_transaction_amount
                        min_fee_amount
                        max_fee_amount
                    }
                }
                maintenance {
                    enabled
                    start_date
                    end_date
                }
            }
`;

export const first_gateway_details_selection = `
            key
            title
            skip_customer_details
            processor_type
            allow_new_card
            redirection_type
            show_amount
            window_size_width
            window_size_height
            is_spread_amount
            additional_fields {
                name
                label
                type
                required
                data
                default_value
                sort_order
                is_account_identifier
                is_mutable
            }
            templates {
                token
                label
                data
            }
            payment_information {
                base_currency
                limits {
                    min_amount
                    max_amount
                }
                fees
                currency_list
            }
            card_tokenization_options {
              token_provider
              enabled
              card_funding_sources
              card_types
              currency_list
            }
`;

export const get_payment_method_groups_panoramic_query = `
    query Payment_method_groups ($format: PaymentMethodOptionsFormat!, $sort: String, $decline_recovery_type: PaymentMethodOptionsDeclineRecoveryType, $skipFirstGateway: Boolean!) {
        payment_method_groups(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {${payment_method_groups_panoramic_selection}}
        first_gateway_details(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) @skip(if: $skipFirstGateway) {${first_gateway_details_selection}}
    }
`;
